<template>
  <div class="details">
    <form-title>基本信息</form-title>
    <info-panel :padding="24">
      <el-row>
        <el-col :span="col">
          <info-item label="所属机构">
            {{ result.agencyName }}
          </info-item>
        </el-col>
        <el-col :span="col">
          <info-item label="累计积分">
            {{ result.agencyPointsTotal }}
          </info-item>
        </el-col>
        <el-col :span="col">
          <info-item label="使用积分">
            {{ result.agencyPointsUsed }}
          </info-item>
        </el-col>
        <el-col :span="col">
          <info-item label="剩余积分">
            {{ result.agencyPointsRemaining }}
          </info-item>
        </el-col>
      </el-row>
    </info-panel>
    <form-title>积分记录</form-title>
    <data-table
      :data="tabelData"
      :pagination="false"
      :table-column="logTableColumn"
      @sortChange="sortChange"
    />
  </div>
</template>
<script>
import infoPanel from '@/components/common/infoPanel.vue';
import infoItem from '@/components/common/infoItem.vue';
import formTitle from '@/components/common/formTitle.vue';
import dataTable from '@/components/common/dataTable.vue';

import axClient from '@/services';
import types, { } from '@/config';

export default {
  name: 'AccountDetails',
  components: {
    formTitle,
    infoPanel,
    infoItem,
    dataTable,
  },
  data() {
    return {
      types,
      col: 6,
      sortType: null,
      result: {},
      tabelData: [],
      pageNum: 1,
      pageSize: 10,
      logTableColumn: [
        {
          key: 'oriOrderNo',
          label: '订单号',
          width: '120px',
          dataType: 'text',
        },
        {
          key: 'oriDesc',
          label: '积分来源',
          width: '160px',
          dataType: 'text',
        },
        {
          key: 'pointsChangeNum',
          label: '积分数',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'createTime',
          label: '修改时间',
          width: 'auto',
          dataType: 'time',
          sortable: 'custom',
        },
      ],
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    // table sortChange
    sortChange(data) {
      const { prop, order } = data;
      const sortType = {
        createTime: {
          ascending: 10,
          descending: 20,
        },
      };
      this.sortType = sortType[prop][order];
      this.getInfo();
    },
    // 详情
    async getInfo() {
      this.result = await axClient.points.getAgencyPoints({ id: this.$route.params.id });
      const result = await axClient.points.pageAgencyPointsRecord({
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        agencyId: this.result.id,
        sortType: this.sortType,
      });
      this.tabelData = result.list;
    },
  },
};
</script>
<style lang="scss" scoped>
.details {
  .title {
    margin-top: 12px;
  }
  .switch-btns {
    padding-bottom: 20px;
  }
}
</style>